import { normalizePromotionCode } from "@scalephant/domain";
import { Link, createFileRoute, redirect, useNavigate } from "@tanstack/react-router";

import { Card } from "../components/ui";
import { RegisterForm } from "../features/auth/RegisterForm";
import { loadMe } from "../features/auth/session";
import { useT } from "../i18n/I18nProvider";

export const Route = createFileRoute("/register")({
  // `code` is the Stripe promotion code in a beta link; it rides along to checkout.
  validateSearch: (search: Record<string, unknown>): { code?: string } => {
    const code = normalizePromotionCode(search.code);
    return code === null ? {} : { code };
  },
  beforeLoad: async ({ context }) => {
    if (await loadMe(context.queryClient)) throw redirect({ to: "/app" });
  },
  component: RegisterPage,
});

function RegisterPage() {
  const t = useT();
  const navigate = useNavigate();
  const { code } = Route.useSearch();
  return (
    <main className="mx-auto w-full max-w-md px-4 py-10">
      <Card title={t("auth.register.title")}>
        <RegisterForm
          promotionCode={code}
          onRegistered={(email) =>
            void navigate({
              to: "/verify-email",
              // A resent link must lead a beta user to checkout like the first one.
              search: code === undefined ? { email } : { email, beta: true },
            })
          }
        />
        <p className="mt-4 flex flex-col gap-1 text-sm">
          <span>
            {t("auth.register.haveAccount")} <Link to="/login">{t("nav.signIn")}</Link>
          </span>
        </p>
      </Card>
    </main>
  );
}
